export default {
  USER: 'USER',
  USER_GROUP: 'USER_GROUP',
};
